import { AbstractDocumentsFacade } from '@pf/shared-services';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
    IDocument,
    IDocumentCreate,
    IDocumentSearchParams,
    IPagedResult,
    PFWmsEntities,
} from '@pf/shared-common';
import { ExceptionFilesService } from '@control-tower/platform-wms';

@Injectable()
export class ExceptionDocumentsFacade extends AbstractDocumentsFacade {
    constructor() {
        const dataService = inject(ExceptionFilesService);

        super(PFWmsEntities.Exception, {
            create$: (entityId: string, document: IDocumentCreate) =>
                dataService.exceptionFilePost({
                    exceptionId: entityId,
                    ...document,
                }) as Observable<IDocument>,
            delete$: (entityId: string, documentId: string) =>
                dataService.exceptionFileDelete({
                    id: documentId,
                    exceptionId: entityId,
                }) as Observable<IDocument>,
            get$: (entityId: string, documentId: string) =>
                dataService.exceptionFileReadById({
                    id: documentId,
                    exceptionId: entityId,
                }) as Observable<IDocument>,
            search$: (entityId: string, params: IDocumentSearchParams) =>
                dataService.exceptionFileSearch({
                    exceptionId: entityId,
                    ...params,
                }) as Observable<IPagedResult<IDocument>>,
            download$: (entityId: string, documentId: string) => {
                return dataService.exceptionFileGet({
                    id: documentId,
                    exceptionId: entityId,
                });
            },
        });
    }
}
